const actions = {
  SET_STATE: 'billing/SET_STATE',
  SUBSCRIBE_TO_PLAN: 'billing/SUBSCRIBE_TO_PLAN',
  UNSUBSCRIBE_TO_PLAN: 'billing/UNSUBSCRIBE_TO_PLAN',
  UNSUBSCRIBE_TO_PLAN_ENDPOINT: 'billing/UNSUBSCRIBE_TO_PLAN_ENDPOINT',
  SUBSCRIBE_MODAL_PROCEED: 'billing/SUBSCRIBE_MODAL_PROCEED',
  STRIPE_CHECKOUT_1: 'billing/STRIPE_CHECKOUT_1',
  STRIPE_CHECKOUT_2: 'billing/STRIPE_CHECKOUT_2',
  RESUBSCRIBE: 'billing/RESUBSCRIBE',
  STRIPE_GOTO_CHECKOUT: 'billing/STRIPE_GOTO_CHECKOUT',
  CANCEL_DOWNGRADE_EOT: 'billing/CANCEL_DOWNGRADE_EOT',
  CHECK_IF_CUSTOM_PLAN: 'billing/CHECK_IF_CUSTOM_PLAN',
  UPDATE_SUBSCRIBE_DOWNGRADE_EOT: 'billing/UPDATE_SUBSCRIBE_DOWNGRADE_EOT',
  GET_USAGE_AND_OVERAGES: 'billing/GET_USAGE_AND_OVERAGES',
  GET_INSIGHTS_DATA: 'billing/GET_INSIGHTS_DATA',
  MULTITENANT_GET_USAGE: 'billing/MULTITENANT_GET_USAGE',
} as const

export default actions
